// extracted by mini-css-extract-plugin
export default {"textInput":"CompanyBaseline_textInput__zj84F","company":"CompanyBaseline_company__ksNdP","baselineItemCompanies":"CompanyBaseline_baselineItemCompanies__y0mhD"};